import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/apps/nocowanie-ssr/app/error.tsx");
